<template>
    <div class="position-relative d-flex align-items-center">
        <div class="btn-acoes left d-flex align-items-center c-pointer txt-blue-2" @click="prev" >
            <span class="bg-white rounded-circle" style=" box-shadow: rgb(0 0 0 / 50%) 0px 0px 5px; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;">
                <i class="fas fa-chevron-left"></i>
            </span>
        </div>

        <div class="w-100">
            <b-carousel id="carousel-1"
                        ref="videoCarousel"
                        v-model="slide"
                        :interval="8000"
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd">

                <b-carousel-slide v-for="item in lstVideos" :key="item.id">
                    <template #img  >
                        <router-link :to="{name:'Video', params:{id:item.id.toString(),n:formatLink(item.titulo)}}" class="c-pointer box-video">
                            <div class="content-image w-100 d-flex align-items-center" :style="'background: linear-gradient(90deg, rgba(22, 49, 66, 0.3) 0%, #163142 22.05%), url('+item.img+');'">
                                <span class="categoria-video txt-p txt-w-8 txt-white txt-size-12 bg-blue-3" v-if="item.categoria && item.categoria != ''">
                                    {{item.categoria}}
                                </span>
                                <span class="txt-p txt-w-8 txt-white txt-size-14 ps-2" v-if="item.titulo && item.titulo != ''">
                                    {{item.titulo}}
                                </span>
                                <div class="divisor mx-2" v-if="item.descricao && item.descricao != ''">

                                </div>
                                <span class="txt-p txt-w-4 txt-white txt-size-12 reduz-texto-1" v-if="item.descricao && item.descricao != ''">
                                    {{item.descricao}}
                                </span>
                            </div>
                            
                        </router-link>
                    </template>

                </b-carousel-slide>

            </b-carousel>
        </div>

        <div class="btn-acoes right d-flex align-items-center c-pointer txt-blue-2" @click="next">
            <span class="icon-circle bg-white rounded-circle" style="">
                <i class="fas fa-chevron-right"></i>
            </span>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'CarouselVideos',
        props: {
            lstVideos: Array,
        },
        data: function () {
            return {
                slide: 0,
                sliding: null

            }
        },
        methods: {
            onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            },

            prev() {
                this.$refs.videoCarousel.prev()
            },
            next() {
                this.$refs.videoCarousel.next()
            },


            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }
                
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .btn-acoes {
        position: absolute;
        
        z-index: 1;

        .icon-circle {
            box-shadow: rgb(0 0 0 / 50%) 0px 0px 5px;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .btn-acoes.left {
        left: -15px;
    }
    .btn-acoes.right {
        right: -15px;
    }

    .box-video {

        .content-image {
            background-position: left center !important;
            padding: 10px 20px;


            .categoria-video {
                border-radius: 5px;
                padding: 5px 10px;
            }

            .divisor {
                border-left: 1px solid white;
                height: 30px;
            }
        }
    }

    .box-video:hover:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,0.3);
    }

</style>

